import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  Switch,
} from '@ais-ui/ui-core';
import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { PortFormValues } from './usePortForm';
import { PortSelect } from './PortSelect';
import { usePermissions } from '../../Permissions/PermissionsProvider';

interface PortFormProps {
  form: UseFormReturn<PortFormValues>;
}

export function PortForm({ form }: PortFormProps) {
  const { messages } = useLocalization();
  const permissions = usePermissions();

  return (
    <Form {...form}>
      <div className="flex flex-col space-y-6">
        {/* Display Settings */}
        <div className="space-y-4">
          <h3 className="text-lg font-medium">
            {messages.settingsPortVisibilityTitle}
          </h3>
          <div className="space-y-4">
            <FormField
              control={form.control}
              name="show_ports"
              render={({ field }) => (
                <FormItem className="flex flex-row items-center justify-between border rounded-lg p-4">
                  <div className="space-y-0.5">
                    <FormLabel className="text-base">
                      {messages.settingsMapPortShowPortsLabel}
                    </FormLabel>
                    <FormDescription>
                      {messages.settingsMapPortShowPortsDescription}
                    </FormDescription>
                  </div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
        </div>

        {/* Favorite Port Settings - requires port permission */}
        {permissions.port && (
          <div className="space-y-4">
            <h3 className="text-lg font-medium">
              {messages.settingsPortFavoriteTitle}
            </h3>
            <div className="space-y-4">
              <FormField
                control={form.control}
                name="favorite_port"
                render={({ field }) => (
                  <FormItem className="border rounded-lg p-4">
                    <div className="space-y-2">
                      <FormLabel className="text-base">
                        {messages.settingsPortFavoritePortLabel}
                      </FormLabel>
                      <FormDescription>
                        {messages.settingsPortFavoritePortDescription}
                      </FormDescription>
                      <FormControl>
                        <PortSelect
                          value={field.value || ''}
                          onValueChange={field.onChange}
                          placeholder="Select your favorite port..."
                          form={form}
                        />
                      </FormControl>
                    </div>
                  </FormItem>
                )}
              />
            </div>
          </div>
        )}
      </div>
    </Form>
  );
}
